const getStoredDashboardScreenshotPresetKey = (dashboardId: string): Nullable<string> =>
  dashboardId ? `dashboardScreenshotPreset-${dashboardId}` : null;

export default getStoredDashboardScreenshotPresetKey;
